module.exports = __webpack_public_path__ + "media/widgets/desc-c12155e9.gif";